export type Microsoft = {
  accessToken: string;
  subdomain: string;
};

export type BackendMicrosoft = {
  access_token: string;
  subdomain: string;
};

export const mapBackendMicrosoftToMicrosoft = (backend: BackendMicrosoft): Microsoft => ({
  accessToken: backend.access_token,
  subdomain: backend.subdomain,
});

export const getMicrosoftMapper = (response: any): Microsoft =>
  mapBackendMicrosoftToMicrosoft(response.data as BackendMicrosoft);
